<template>
  <div :key="componentKey">
    <modal
      :closeable="state === 'IN_PENDING'"
      @close="$emit('close', false)"
      :withoutShadow="true"
      class="normal-modal-of"
    >
      <div slot="body">
        <div v-if="state === 'IN_PENDING'" class="text-center">
          <barcode-scanner-animation></barcode-scanner-animation>
          <h4 class="mt-4 text-center barcode-text">
            {{ $t('DepositTicket.PleaseScanInfo') }}
          </h4>
          <input
            type="text"
            v-model="scanCodeInternal"
            :placeholder="$t('DepositTicket.Barcode')"
            class="form-control mb-2"
            ref="scanCodeRef"
          />
          <alert-message v-if="scanErrorMessage" error withoutIcon :description="$t(scanErrorMessage)" />
          <alert-message v-if="invalidScanCode" error withoutIcon :description="$t('DepositTicket.InvalidScanCode')" />
          <button
            class="mt-2 btn btn-lg btn-primary barcode-button"
            @click="scanBarcode()"
            :disabled="!scanCodeInternal"
          >
            {{ $t('DepositTicket.ScanBarcode') }} <i v-if="false" class="fa fa-spinner fa-spin"></i>
          </button>
          <button
            class="mt-2 btn btn-lg btn-success ml-2"
            @click="triggerBarcodeScannerCamera('DEPOSIT_TICKET_STORE')"
            v-if="clientType === 'ANDROID_TABLET'"
          >
            {{ $t('DepositTicket.TriggerCamera') }}
            <i class="icon icon-screenshot"></i>
          </button>
        </div>
        <barcode-scanner-deposit-ticket-content v-if="state === 'IN_BALANCE'"></barcode-scanner-deposit-ticket-content>
        <!-- <barcode-scanner-wager-ticket-content v-if="state === 'IN_WAGER'"></barcode-scanner-wager-ticket-content> -->
        <div class="d-flex justify-content-center">
          <button v-if="state !== 'IN_PENDING'" class="mt-4 mr-2 btn btn-lg btn-danger" @click="tryLogout()">
            {{ $t('Cancel') }}
          </button>
          <button v-if="state === 'IN_BALANCE'" class="mt-4 ml-2 btn btn-lg btn-primary" @click="$emit('close', false)">
            {{ $t('DepositView.MoneyGram.GetReceiverInfo') }}
          </button>
        </div>
      </div>
    </modal>
    <BModal v-if="state === 'IN_WAGER'" :closeable="true" @close="resetState()" class="barcode-scan-modal b-modal-ofo">
      <div slot="header">
        <span class="title">{{ $t('WagerTicket.Information') }}</span>
      </div>
      <div class="confirmation-wrapper" slot="body">
        <div class="rows-wrapper">
          <barcode-scanner-wager-ticket-content></barcode-scanner-wager-ticket-content>
        </div>
      </div>
    </BModal>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import BarcodeScannerAnimation from './BarcodeScannerAnimation';
import BarcodeScannerDepositTicketContent from './BarcodeScannerDepositTicketContent';
import BarcodeScannerWagerTicketContent from './BarcodeScannerWagerTicketContent';
import { LoginTypes, ExternalWagerLoginTypes } from '@/utils/enums';
import { triggerBarcodeScannerCamera } from '@/plugins/barcodeUpdater';
import BModal from '@/components/shared/BonusModal';

export default {
  components: {
    BarcodeScannerAnimation,
    BarcodeScannerDepositTicketContent,
    BarcodeScannerWagerTicketContent,
    BModal,
  },
  computed: {
    ...mapState('depositTicketStore', [
      'scanStatus',
      'balanceStatus',
      'balanceResponse',
      'state',
      'ticketGradedBets',
      'ticketOpenBets',
      'scanErrorMessage',
    ]),
    ...mapFields('depositTicketStore', ['scanCode', 'invalidScanCode', 'isLoadingLoadWallet']),
    ...mapState('player', ['loginType']),
    ...mapState('settings', ['clientType', 'macAddress']),
    ...mapFields('player', ['openLogoutModal']),
  },
  data() {
    return {
      componentKey: 0,
      scanCodeInternal: '',
    };
  },
  watch: {
    scanCode(newValue) {
      localStorage.setItem('PREF_SCAN_CODE', newValue);
    },
    scanCodeInternal(value) {
      if (value && value.length === 13) {
        setTimeout(() => {
          this.scanBarcode();
        }, 100);
      }
    },
  },
  methods: {
    triggerBarcodeScannerCamera,
    ...mapActions('depositTicketStore', ['tryScanBarcode']),
    ...mapActions('clerkWagerStore', ['tryScanWagerBarcode']),
    ...mapActions({
      logoutAndRefresh: 'player/logoutAndRefresh',
      getLoyaltyCardDetails: 'settings/getLoyaltyCardDetails',
    }),
    ...mapMutations('player', ['setLoginType']),
    ...mapMutations('depositTicketStore', ['resetState', 'setScanErrorMessage']),
    scanBarcode() {
      const tempBarcode = this.scanCodeInternal.trim();
      this.scanCode = tempBarcode;
      localStorage.setItem('PREF_SCAN_CODE', tempBarcode);
      console.log('ScanBarcode', tempBarcode);
      switch (tempBarcode.substring(0, 1)) {
        case 'C': //Loyalty card
          this.getLoyaltyCardDetails(tempBarcode);
          break;
        case 'D': //Depoist ticket
          this.tryScanBarcode(tempBarcode);
          break;
        case 'B': //Wager ticket
          this.tryScanBarcode(tempBarcode);
          break;
        case 'W': //Wallet
          this.tryScanBarcode(tempBarcode);
          break;
        default:
          break;
      }
      this.scanCodeInternal = '';
    },
    tryLogout() {
      if (this.state === 'IN_WAGER') {
        this.$emit('close', false);
        this.resetState();
        if (this.loginType === ExternalWagerLoginTypes.DepositTicket) {
          this.logoutAndRefresh(this.$isElectron);
        }
      } else {
        if (this.loginType === ExternalWagerLoginTypes.DepositTicket) {
          this.logoutAndRefresh(this.$isElectron);
        }

        if (this.loginType === ExternalWagerLoginTypes.ClerkDepositTicket) {
          this.setLoginType(LoginTypes.Clerk);
          this.$emit('close', false);
        }
        this.resetState();
        this.componentKey += 1;
      }
    },
  },
  mounted() {
    this.scanCode = localStorage.getItem('PREF_SCAN_CODE') || '';
    this.$nextTick(() => {
      setTimeout(() => {
        this.$refs.scanCodeRef.focus();
      }, 100);
    });
    this.invalidScanCode = false;
    this.componentKey += 1;
  },
  created() {
    this.scanCode = localStorage.getItem('PREF_SCAN_CODE') || '';
    this.setScanErrorMessage('');
  },
  beforeDestroy() {
    localStorage.setItem('PREF_SCAN_CODE', '');
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../sass/variables';

.scan-code {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 15px 100px;
  font-size: 15px;
  background-color: $pale-grey-two;
  color: #444444;
  font-weight: 600;
  border-radius: 3px;
}

.barcode-text {
  font-size: 1.2rem;
  margin-bottom: 20px;
}

.barcode-button:hover {
}
</style>
